'use strict';
'use es6';

// describe the parameters of type hubs_* that should overwrite the parameters utm_* before sending to amplitude
// example: the value of 'hubs_campaign', if found will be replacing the value of 'utm_campaign'

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hubs_campaign: 'utm_campaign',
  hubs_content: 'utm_content',
  hubs_medium: 'utm_medium',
  hubs_source: 'utm_source',
  hubs_cta: 'utm_id', // legacy, all links jusing hubs_cta should be changed using hubs_id so that this mapping can be removed
  hubs_id: 'utm_id'
};
module.exports = exports['default'];